import { useEffect } from "preact/hooks"
import { MappedImage } from "src/utils/fw"
import { effect } from "./dayOne"

export default (day) => {
    const achievements = [
        "6fca87ab-d73a-4bbd-9aa3-0b5961568f53",
        "09905f9d-5e72-492b-80b1-ad9ff923f6ee",
        "6f6cf07a-8d62-42b1-85e8-8601b948a047"
    ]

    const days = [
        "https://assets.swoogo.com/uploads/full/4566338-671815939582b.png",
        "https://assets.swoogo.com/uploads/full/4566337-67181593a410b.png",
        "https://assets.swoogo.com/uploads/full/4566339-67181593a4bf3.png"
    ]

    const iframes = [
        "https://open.spotify.com/embed/episode/3w8HPrr6f0YTzh5hl1il1Z?utm_source=generator",
        "https://open.spotify.com/embed/episode/5GZg6vbkVBCDPEq7hBrFdL?utm_source=generator",
        "https://open.spotify.com/embed/episode/5Pb9tmWQYscyHEz32xeHvq?utm_source=generator"
    ]

    const sigleLine = {
        label: "Subscribe to our Podcast",
        width: "42%",
        height: "6%",
        left: "28.8%",
        top: "78%",
        href: "https://www.isflive.org/s/isf-videos-podcasts",
        target: "_blank"
    }

    const links = [
        [sigleLine],
        [{...sigleLine, top: "82.3%"}],
        [sigleLine]
    ]

    const label = [
        "The power of Inclusive Leadership - Helle Thorning-Schmidt", 
        "Cyber Warfare and Democracy in the Age of Artificial Intelligence - Mariarosaria Taddeo", 
        "The Never Normal - Peter Hinssen"
    ]

    return [
        () => {
            useEffect(effect(achievements[day]), [])

            return <MappedImage links={links[day]} imageURL={days[day]} imageStyle="width:unset;">
                {iframes[day] ? <iframe style={{
                    position: "absolute",
                    top: "31.5%",
                    left: "11.1%",
                    width: "78.35%",
                    height: "28%"
                }}
                src={iframes[day]} 
                frameBorder="0" 
                height="80%"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"/> : undefined }
            </MappedImage>
        },
        {
            name: label[day],
            dismiss: {
                width: "2%",
                height: "3%",
                left: "87.5%",
                top: "10.5%"
            }
        }
    ]

}